// extracted by mini-css-extract-plugin
module.exports = {"mainDesktop":"PublicLayoutDesktop-module__mainDesktop__yaJ1N","container":"PublicLayoutDesktop-module__container__XI2MB"};